import React, { useEffect, useState } from 'react';
import { Stack, Group, Select } from '@mantine/core';
import ModalWrapper from '../../components/elements/ModalWrapper';
import Button from '../../components/elements/Button';
import { FiFilter } from 'react-icons/fi';
import { Controller, useForm } from 'react-hook-form';
import dayjs from 'dayjs';
import { generateYearList } from '../../utilities/generateYearList';

interface ChartFilterRaterProps {
  isOpen: boolean;
  onClose: () => void;
  onFilter: (data: any) => void;
  onReset: () => void;
}

const ChartFilterRater: React.FC<ChartFilterRaterProps> = ({
  isOpen,
  onClose,
  onFilter,
  onReset
}) => {
  const { control, reset, handleSubmit } = useForm({
    defaultValues: {
      yearFrom: null,
      yearTo: null
    }
  });

  const onSubmit = (data: any) => {
    onFilter(data);
    onClose();
  };

  const handleReset = () => {
    reset({
      yearFrom: null,
      yearTo: null
    });
    onClose();
    onReset();
  };

  const [selectedYearFrom, setSelectedYearFrom] = useState(
    dayjs().get('year').toString()
  );

  const [selectedYearTo, setSelectedYearTo] = useState(
    dayjs().get('year').toString()
  );

  return (
    <ModalWrapper title="Filter" isVisible={isOpen} onClose={onClose}>
      <form onSubmit={handleSubmit(onSubmit)}>
      <Stack>
      <Group gap={16} justify="space-between">
        <Controller
          name="yearFrom"
          control={control}
          render={({ field }) => (
            <Select
              label="Year From"
              value={selectedYearFrom}
              data={generateYearList('before-now').sort(
              (a, b) => Number(b) - Number(a)
              )}
              {...field}
              placeholder="Select a Year"
            />
          )}
        />
        <Controller
          name="yearTo"
          control={control}
          render={({ field }) => (
            <Select
              label="Year To"
              value={selectedYearTo}
              data={generateYearList('before-now').sort(
              (a, b) => Number(b) - Number(a)
              )}
              placeholder="Select a Year"
              {...field}
            />
          )}
        />
      </Group>
        <Group justify='flex-end' mt="md" gap={10}>
          <Button variant='error-beelajar' onClick={handleReset}>
            Reset Filter
          </Button>
          <Button type="submit">
            <FiFilter />
              Apply Filter
          </Button>
        </Group>
      </Stack>
      </form>
    </ModalWrapper>
  );
};

export default ChartFilterRater;
